import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import darkTheme from '../../../src/theme';

const checkoutContainer = {            
    position: 'fixed',
    width: '36%',
    maxWidth: '36%',
    right: 0,
    bottom: 0,
    paddingLeft: darkTheme.spacing(3),  
    paddingRight: darkTheme.spacing(3),  
    paddingTop: darkTheme.spacing(2),
    paddingBottom: darkTheme.spacing(3),
    boxShadow: '2px -2px 8px 0px #000',
    borderRadius: 5,
    marginBottom: -2,
    [darkTheme.breakpoints.down("md")]: {
        width: '100%',
        maxWidth: '100%',
        paddingLeft: darkTheme.spacing(4),  
        paddingRight: darkTheme.spacing(4),  
        paddingTop: darkTheme.spacing(2),
        paddingBottom: darkTheme.spacing(4),
    },
    background: darkTheme.palette.background.alternate,           
    '& h4': {
        fontSize: 30,
        color: darkTheme.palette.primary.title,
        fontWeight: 700,
        textTransform: 'capitalize !important',
    },
    '& h5': {
        fontSize: 14,
        color: darkTheme.palette.primary.dates,
        textTransform: 'capitalize !important',
        fontWeight: 100,
    },
};

function CheckoutContainer({totalCost, totalNoOfTickets, onPageRedirect}) {    
    const [loading, setLoading] = useState(false);
    const onPageRedirect2 = (e) => {
        e.preventDefault();
        onPageRedirect(e);
        setLoading(true)
    }

  return (                      
    <Stack        
        display="flex"
        justifyContent="space-between"
        flexDirection="row"
        sx={checkoutContainer}
    >
        <Typography component="div">
            <Typography variant="h5">Total Amount</Typography>
            {totalCost > 0 ? (
                <Typography variant="h4">
                    <CurrencyRupeeIcon sx={{fontSize: 16}} />{totalCost}
                </Typography>
            ):(
                <Typography variant="h4">Free</Typography>
            )}
        </Typography>
        <Typography component="div">
            <LoadingButton
                className={!loading ? `themeBtn` : `themeBtnDisabled`}
                sx={{ width: "100%", py: 1.5, px: 5 }}
                variant="contained"
                loading={loading}
                onClick={onPageRedirect2}                 
                loadingPosition="end"
                
            >
            {!loading ? <>Proceed&nbsp;&nbsp;<b>({totalNoOfTickets})</b></> : 'please wait...'}
            </LoadingButton>
        </Typography>
    </Stack>        
  );
}

export default CheckoutContainer;

